import React, { useState, useEffect } from 'react';
import { getRankedLeaderboard, rankedWinPercentage } from '../../firebase/players';

/**
 * Landing-page teaser showing the top few ranked players, with a CTA to the full
 * rankings. Renders nothing until there are ranked players — so it self-activates
 * once the leaderboard has data (and never shows an empty section before then).
 */
export default function TopPlayersTeaser({ onNavigate }) {
  const [top, setTop] = useState([]);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const data = await getRankedLeaderboard(3);
        if (active) setTop(data);
      } catch (e) { /* leaderboard unavailable — just hide the teaser */ }
    })();
    return () => { active = false; };
  }, []);

  if (top.length === 0) return null;

  const medal = (i) => (i === 0 ? '🥇' : i === 1 ? '🥈' : '🥉');

  return (
    <section style={{ padding: '64px 20px', backgroundColor: 'var(--bg-primary)' }}>
      <div style={{ maxWidth: 720, margin: '0 auto', textAlign: 'center' }}>
        <h2 style={{ fontSize: 28, fontWeight: 800, margin: '0 0 6px', color: 'var(--text-primary)' }}>
          Top Ranked Players
        </h2>
        <p style={{ color: 'var(--text-secondary)', fontSize: 15, margin: '0 0 28px' }}>
          Register and play in tournaments to climb the rankings.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {top.map((p, i) => {
            const rs = p.stats || {};
            return (
              <div
                key={p.id}
                style={{
                  display: 'flex', alignItems: 'center', gap: 14, padding: '14px 18px',
                  backgroundColor: 'var(--bg-card)', border: '1px solid var(--border-color)', borderRadius: 12,
                  boxShadow: 'var(--shadow-sm)',
                }}
              >
                <div style={{ fontSize: 22, width: 32, textAlign: 'center' }}>{medal(i)}</div>
                {p.photoURL ? (
                  <img src={p.photoURL} alt={p.displayName} style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover' }} />
                ) : (
                  <div style={{
                    width: 40, height: 40, borderRadius: '50%', backgroundColor: 'var(--accent-primary)', color: '#fff',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700,
                  }}>
                    {(p.displayName || '?').charAt(0).toUpperCase()}
                  </div>
                )}
                <div style={{ flex: 1, textAlign: 'left', fontWeight: 700, color: 'var(--text-primary)' }}>
                  {p.displayName || 'Anonymous'}
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontWeight: 800, color: 'var(--accent-primary)' }}>{rs.tournamentWins || 0} wins</div>
                  <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>{rankedWinPercentage(rs)}% win rate</div>
                </div>
              </div>
            );
          })}
        </div>

        <button
          onClick={() => onNavigate('leaderboard')}
          style={{
            marginTop: 28, padding: '12px 28px', borderRadius: 10, border: 'none', cursor: 'pointer',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: '#fff', fontSize: 16, fontWeight: 700,
          }}
        >
          View Full Rankings →
        </button>
      </div>
    </section>
  );
}
